<style lang="less" scoped>
.dynamic-form-contain {
    .header-common-style {
        text-align:center!important;
        font-weight: 700;
        border-bottom: 1px solid  rgb(128,128,128);
        .header-common-tr {
            // padding: 10px;
           
        }
        .border {
            width: 100%;
            height: 1px;
            background: rgb(128,128,128);
        }
        td {
            color: rgba(0, 0, 0, 0.6);
            font-size: 12px;
            height: 48px;
            border-top:  thin solid rgba(0, 0, 0, 0.12);
            border-bottom:  thin solid rgba(0, 0, 0, 0.12);
            border-right:  thin solid rgba(0, 0, 0, 0.12);
        }
        td:first-child {
            border-left:  thin solid rgba(0, 0, 0, 0.12);
        }
        .td-align-center {
             text-align:center;
        }
    }
    .body-common-style{
      td {
            min-height:48px;
            border-bottom:  thin solid rgba(0, 0, 0, 0.12);
            border-right:  thin solid rgba(0, 0, 0, 0.12);
      }
       td:first-child {
            border-left:  thin solid rgba(0, 0, 0, 0.12);
        }
        .negative-red {
          /deep/.v-input__control {
            input {
              color: #ff3300;
            }
          }
        }
    }
    .flex-contain {
        display: flex;
        align-items: center;
    }
    .header-common-value-tr {
        text-align: center;
    }
    .negative-red-dis {
     color: #ff3300;
    }
}
</style>
<template>
  <div>
    <v-form
      ref="form"
      :value="true"
      class="dynamic-form-contain"
      style="width: 100%;"
    >
      <v-data-table
        dense
        disable-sort
        :headers="data_obj._header"
        :items="data_obj._value"
        :items-per-page="Infinity"
        hide-default-header
        hide-default-footer
      >
        <template v-slot:[`header`]="{ props }">
          <thead class="header-common-style">
            <tr class="header-common-tr">
              <td 
                v-for="(item,index) in props.headers"
                :key="index"
                :style="{
                  width:item.width,
                  'min-width': item.width,
                  'text-align':item.align
                }"
              >
                <!-- 月份 -->
                <div
                  v-if="item.type==='month'"
                  class="flex-contain"
                >
                  <v-menu
                    v-model="item.showDateMenu"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        :value="item.value"
                        label=""
                        placeholder="申请时间"
                        readonly
                        v-bind="attrs"
                        :rules="rules.date_check"
                        v-on="on"
                      />
                    </template>
                    <v-date-picker
                      v-model="item.value"
                      type="month"
                      no-title
                      scrollable
                      reactive
                      locale="zh-cn"
                      :show-current="false"
                      :allowed-dates="allowedMonths"
                      @change="changeDate"
                    >
                      <v-spacer />
                      <v-btn
                        text
                        color="primary"
                        @click="item.showDateMenu = false"
                      >
                        关闭 
                      </v-btn>
                    </v-date-picker>
                  </v-menu>
                  <div v-show="props.headers.length>3">
                    <v-btn
                      fab
                      dark
                      height="18"
                      width="18"
                      color="primary"
                      @click="deleteMonth(index)"
                    >
                      <v-icon dark>
                        mdi-minus
                      </v-icon>
                    </v-btn>
                  </div>
                  <div v-show="props.headers.length<5&&index===props.headers.length-2">
                    <v-btn
                      style="margin-left:10px;"
                      fab
                      dark
                      height="18"
                      width="18"
                      color="primary"
                      @click="addMonth(index)"
                    >
                      <v-icon dark>
                        mdi-plus
                      </v-icon>
                    </v-btn>
                  </div>
                </div>
                <div v-else>
                  {{ item.text }}
                </div>
              </td>
            </tr>
          </thead>
        </template>
        <template v-slot:[`item`]="{ item,headers,index:item_index }">
          <tr class="body-common-style">
            <td 
              v-for="(header,header_index) in headers"
              :key="header_index"
              :style="{
                width:header.width,
                'min-width': header.width,
                'text-align': header.align,
              }"
            >
              <div 
                v-if="header.value==='title_id'&&item.is_sum"
                style="line-height:48px"
              >
                总计
              </div>
              <div v-if="header.type==='month'&&header.value&&!item.is_sum">
                <v-text-field
                  v-model="item[header.value]"
                  :class="{'negative-red':item[header.value]<0}"
                  label=""
                  placeholder="请输入..."
                  type="number"
                  required
                  :rules="rules.budget_amount"
                />
              </div>
              <!-- 科目类型选择 -->
              <div v-if="header.value==='title_id'&&!item.is_sum">
                <div
                  class="flex-contain"
                >
                  <v-btn
                    v-show="data_obj._value.length>2" 
                    style="margin-right:10px"
                    fab
                    dark
                    height="18"
                    width="18"
                    color="primary"
                    @click="deleteValueItem(item_index)"
                  >
                    <v-icon dark>
                      mdi-minus
                    </v-icon>
                  </v-btn>
                  <v-btn
                    v-show="item_index===data_obj._value.length-2" 
                    style="margin-right:10px"
                    fab
                    dark
                    height="18"
                    width="18"
                    color="primary"
                    @click="addNewValueItem"
                  >
                    <v-icon dark>
                      mdi-plus
                    </v-icon>
                  </v-btn>
                  <div>
                    <v-autocomplete 
                      v-model="item.title_id"
                      label="科目名称"
                      item-value="id"
                      clearable
                      :items="analysis_leaf_titles_comp"
                      :item-text="({full_name}={})=>full_name"
                      :rules="rules.title_id"
                      :item-disabled="titleSelected(data_obj)"
                      :filter="search"
                    >
                      <template v-slot:no-data>
                        <v-list-item>
                          <v-list-item-title>
                            暂无数据
                          </v-list-item-title>
                        </v-list-item>
                      </template>
                    </v-autocomplete>
                  </div>
                </div>
              </div>
              <!-- 行求和 -->
              <div 
                v-if="header.value==='sum'&&!item.is_sum"
                :class="{'negative-red-dis':rowSum(item)<0}"
              >
                {{ formattingNumber(rowSum(item),2) }}
              </div>
              <!-- 列求和 -->
              <div 
                v-if="item.is_sum&&header.value!=='title_id'&&header.value!=='sum'"
                :class="{'negative-red-dis':colSum(header)<0}"
              >
                {{ formattingNumber(colSum(header),2) }}
              </div>
              <!-- 对所有求和 -->
              <div
                v-if="item.is_sum&&header.value!=='title_id'&&header.value==='sum'"
                :class="{'negative-red-dis':allSum(header)<0}"
              >
                {{ formattingNumber(allSum(header),2) }}
              </div>
            </td>
          </tr>
        </template>
      </v-data-table>
    </v-form>
  </div>
</template>

<script>
  import { mapGetters } from "vuex";
  import { formattingNumber } from '../../../../libs/util'
  import { createMonthHeader, createValue, nonNull, blankdecimalRule } from '../utils'
  export default {
    props: {
      value:{
        type: Object
      },
      startDate: {
        type: String
      }
    },
    data() {
      this.formattingNumber = formattingNumber
      return {
        data_obj: this.value,
      }
    },
    methods: {
      search({ full_name, pinyin }, queryText) {
        if ([undefined, '', null].includes(queryText)) {
          return true
        }
        queryText += ''
        if ((/[a-zA-Z\t]+/g).test(queryText)) { // 拼音匹配
          queryText = queryText.split(/\s+/g).join('')
          let str = ''
          for (let i = 0; i < queryText.length; i++) {
            str = str + queryText[i] + '[a-zA-Z]*'
          }
          queryText = new RegExp(str)
        }

        if (queryText instanceof RegExp) {
          return queryText.test(pinyin)
        } else {
          // 汉字匹配
          let index = 0
          for (let i = 0, len = full_name.length; i < len; i++) {
            if (queryText[index] === full_name[i]) {
              index++
            }
          }
          return index >= queryText.length
        }
      },
      validate() {
        return this.$refs.form.validate()
      },
      resetValidation() {
        this.$refs.form.resetValidation()
      },
      // 删除月份
      deleteMonth(index) {
        const deletedMonth = this.data_obj._header.splice(index, 1)[0]
        this.data_obj._value.forEach(item => {
          delete item[deletedMonth.value]
        });
      },
      // 添加月份
      addMonth(index) {
        this.data_obj._header.splice(index + 1, 0, createMonthHeader())
      },
      // 删除数据条目
      deleteValueItem(index) {
        this.data_obj._value.splice(index, 1)
      },
      // 添加数据条目
      addNewValueItem() {
        this.data_obj._value.splice(this.data_obj._value.length - 1, 0, createValue({ is_sum:false }))
      },
      // 修改时间
      changeDate(time) {
        const selected_date_arr = this.data_obj._header.filter(item => item.type === 'month' && item.value).map(item => item.value)
        const selected_date_hash = selected_date_arr.reduce((total, key) => {
          total[key] = true
          return total
        }, {})
        const new_key = time // 新增的key
        let old_key = null
        if (this.data_obj._value.length <= 1) {
          return
        }
        // 之前选择的时间
        const selected_value_key_arr = Object.keys(this.data_obj._value[0])
          .filter(key => key !== 'title_id' && key !== 'is_sum')
        const selected_value_key_hash = selected_value_key_arr.reduce((total, key) => {
          total[key] = true
          return total
        }, {})
        // 如果是用户重复点击相同日期
        if (selected_value_key_hash[new_key]) {
          return 
        }
        // diff 出旧的key
        selected_value_key_arr.forEach(key => {
          if (!selected_date_hash[key]) {
            old_key = key
          }
        })
        // 替换新的日期
        this.data_obj._value.forEach((item, index) => {
          if (item.is_sum) {
            return
          }
          item[new_key] = (old_key && item[old_key]) || ''
          const current_item = {...item}
          this.$set(this.data_obj._value, index, current_item)
          delete current_item[old_key]
        })
      },
      // 可选时间
      allowedMonths(date) {
        /* -------------------------------------------------------------- */
        const date_arr = date.split('-')
        const current_month_header = this.data_obj._header.filter(item => item.showDateMenu)[0]
        const header_month_selected = this.data_obj._header.filter(item => item !== current_month_header && (item.type === 'month' && item.value))
        const selected_date_one = (header_month_selected.length && header_month_selected[0].value.split('-')) || []
        const is_not_same_year = header_month_selected.length && selected_date_one[0] !== date_arr[0] // 不是同一年的
        const is_not_same_seaon = header_month_selected.length && (Math.ceil(Number(date_arr[1]) / 3) !== Math.ceil(Number(selected_date_one[1]) / 3)) // 不是同一个季度 
        const is_selected_month = header_month_selected.some(item => item.value === date) // 已选择月份
        if (this.dateStartCheck(date) || is_not_same_year || is_not_same_seaon || is_selected_month) {
          return false
        }
        return true
      },
      // 科目选择
      titleSelected(data_arr_item) {
        return ({ id }) => {
          const selected_title_id_arr = data_arr_item._value.filter(item => !['', undefined, null].includes(item.title_id)).map(item => item.title_id)
          return selected_title_id_arr.includes(id)
        }
      },
      // 对行 求和
      rowSum(item) {
        const except_key = {
          is_sum:true,
          title_id: true
        }
        return Object.keys(item).reduce((total, key) => {
          if (except_key[key]) {
            return total
          }
          return math.eval(`${total}+${item[key] || 0}`)
        }, 0)
      },
      // 对列 求和
      colSum({value}) {
        return this.data_obj._value.reduce((total, item) => {
          return math.eval(`${total}+${item[value] || 0}`)
        }, 0)
      },
      allSum() {
        return this.data_obj._value.reduce((total, item) => {
          return math.eval(`${total}+${this.rowSum(item)}`)
        }, 0)
      },
      // 验证时间
      dateStartCheck(date) {
        if (!this.startDate) {
          return false
        }
        const startDate = this.startDate.slice(0, 7)
        const current = moment().format('YYYY-MM')
        const current_month = startDate.slice(-2)
        const max_month = startDate.slice(0, 4) + '-' + Math.floor(Number(current_month) / 3) * 3 + 3
        return date < startDate || date < current || date > max_month
      }
    },
    computed: {
      ...mapGetters('async', {
        analysis_leaf_titles: 'analysis_leaf_titles', // 分析
        analysis_leaf_titles_hash: 'analysis_leaf_titles_hash'
      }),
      analysis_leaf_titles_comp() {
        return this.analysis_leaf_titles.filter(item => !item.del)
      },
      rules() {
        return {
          date_check: [
            data => !!data || '请选择申请时间'
          ],
          title_id: [
            nonNull('分析科目必选')
          ],
          budget_amount:[
            blankdecimalRule
          ],
        }
      },
    },
    watch: {
      watch: {
        data_obj:{
          handler(data) {
            this.$emit('input', data)
          },
          deep: true
        },
        value: {
          handler(data) {
            this.data_obj = data
          },
          deep: true
        }
      },
    }
  }
</script>